import { format, subDays } from 'date-fns';
import { computed, ref } from 'vue';
import useFeatureFlags from '@/composables/useFeatureFlags';

const DATE_RANGE_FORMAT = 'yyyy-MM-dd';
const DEFAULT_RANGE_DAYS = 365;

// Per-graph analytics date-range window. Each chart owns its own range, so the
// picker shown beside that chart's W2W/M2M toggle only affects that chart.
// Defaults to the last year (which matches the API's own default window).
export default () => {
  const { portalUpdatesJan2026Enabled } = useFeatureFlags();

  const from = ref(format(subDays(new Date(), DEFAULT_RANGE_DAYS), DATE_RANGE_FORMAT));
  const to = ref(format(new Date(), DATE_RANGE_FORMAT));

  // The picker (and this whole range feature) is gated behind the flag. When it
  // is off, send no range so requests keep hitting the pre-flag unparameterized
  // API path rather than the concrete defaults above.
  const apiFrom = computed(() => (portalUpdatesJan2026Enabled.value ? from.value : null));
  const apiTo = computed(() => (portalUpdatesJan2026Enabled.value ? to.value : null));

  return { from, to, apiFrom, apiTo };
};
